import { render, staticRenderFns } from "./MedicalHistoryTemplate.vue?vue&type=template&id=34576398"
import script from "./MedicalHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./MedicalHistoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports